/**
 * Enlace a una capacitación cuando solo se conoce el id del CURSO. La página de
 * detalle (/courses/:id) recibe el id de la inscripción; /courses/by-course/:courseId
 * busca la inscripción propia de ese curso y redirige a ella.
 */
export function courseLink(courseId: number): string {
  return `/courses/by-course/${courseId}`;
}
